import { render, staticRenderFns } from "./SucursalContabilidad.vue?vue&type=template&id=7aaa43c7&scoped=true&"
import script from "./SucursalContabilidad.vue?vue&type=script&lang=js&"
export * from "./SucursalContabilidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aaa43c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VList,VRow,VSkeletonLoader})
